import type { LoginData, RegisterData } from '@/api/auth'
import type { PublicConfig, UserInfo } from '@/types/domain'
import { defineStore } from 'pinia'
import { authApi } from '@/api'
import { redirectTo } from '@/platform/navigation'
import { clearAuthStorage, getStorage, removeStorage, setStorage } from '@/platform/storage'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: getStorage('token'),
    expire: getStorage('expire'),
    user: null as UserInfo | null,
    publicConfig: null as PublicConfig | null,
  }),
  getters: {
    isLoggedIn: state => Boolean(state.token),
    displayName: state => state.user?.nickname || state.user?.realName || state.user?.username || '未登录',
  },
  actions: {
    async loadPublicConfig() {
      this.publicConfig = await authApi.getPublicConfig().catch(() => null)
    },
    async loadUser() {
      if (!this.token) {
        return
      }
      this.user = await authApi.getUserInfo().catch(() => null)
    },
    async login(payload: LoginData) {
      const result = await authApi.login(payload)
      this.token = result.token
      this.expire = String(result.expire || '')
      setStorage('token', result.token)
      setStorage('expire', this.expire)
      await this.loadUser()
    },
    async register(payload: RegisterData) {
      const result = await authApi.register(payload)
      this.token = result.token
      this.expire = String(result.expire || '')
      setStorage('token', result.token)
      setStorage('expire', this.expire)
      await this.loadUser()
    },
    logout() {
      this.token = ''
      this.expire = ''
      this.user = null
      clearAuthStorage()
      void redirectTo('/pages/login/index')
    },
  },
})
